import store from "../store";
import { commonService } from "./common.service";
import { env } from "../env";

export const collectiviteService = {
  getCommunesbyCriteria,
  getCommunesByInseeDep,
  getCommuneGeomByInsee,
  getCommuneGeomByParc,
  getRegions,
  getDepartements
};

function getCommuneGeomByInsee(codeInsee) {
  const url = new URL(`${env.apiUrl}/communes/${codeInsee}`);

  return commonService.getRessource(url);
}

function getCommuneGeomByParc(parc) {
  const url = new URL(`${env.apiUrl}/communes/codeinsees`);

  parc.inventaireCommunes.forEach((inventaireCommune) => {
    url.searchParams.append("codeInsee", inventaireCommune.codeInsee);
  });

  return commonService.getRessource(url);
}

function getCommunesbyCriteria(search) {
  const url = new URL(`${env.apiUrl}/communes`);

  if (search !== null) {
    url.searchParams.append("search", search);
  }

  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + store.getters.token,
      Profil: store.getters.profil
    }
  };

  return fetch(url, requestOptions)
    .then(response => {
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

function getCommunesByInseeDep(inseeDep) {
  const url = new URL(`${env.apiUrl}/communes`);

  if (inseeDep !== null) {
    url.searchParams.append("inseeDep", inseeDep);
  }

  return commonService.getRessource(url);
}

function getRegions() {
  const url = new URL(`${env.apiUrl}/regions`);

  return commonService.getRessource(url);
}

function getDepartements() {
  const url = new URL(`${env.apiUrl}/departements`);

  return commonService.getRessource(url);
}
